<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 footer-top p-0">
        <div class="footer-image-wrapper d-md-block d-lg-block " [ngClass]="isMobile ? 'd-none' : 'd-block'">
        </div>
       </div>

    </div>
  </div>
 <!-- //whatsapp start -->
  <div class="whatsapp-wrapper" *ngIf="isShowChatbot"
    [ngClass]="[this.router.url.includes('/product-list') || this.router.url.includes('/product-details') ? 'whatsapp-wrapper1' : 'whatsapp-wrapper']">
   <!-- For sandbox----------//5000 //8000 //3000 -------->
    <!-- <a rel="noopener noreferrer"
      href="
  https://api.whatsapp.com/send/?phone=447860099299&text=Hi,%20I%20need%20assistance%20in%20booking%20a%20Tata%20vehicle%20online&app_absent=0"
      target="_blank" class="icon"> -->
     <!--For production------- //4000--------->
      <a rel="noopener noreferrer"
  href="
    https://api.whatsapp.com/send/?phone=918655429100&text=Hi,%20I%20need%20assistance%20in%20booking%20a%20Tata%20vehicle%20online&app_absent=0"
      target="_blank"
  target="_blank" class="icon">

      <img alt="whatsapp" [src]='environment1 + "assets/images/whatsapp.webp"' width="100%" height="100%" />
    </a>
  </div>
<!-- //whatsapp end -->
  <!-- start chat floating icon -->

  <div
  *ngIf="isShowChatbot"

    [ngClass]="[
      this.router.url.includes('/product-list') ||
      this.router.url.includes('/product-details')
        ? 'chat-floating1'
        : 'chat-floating'
    ]"
  >
    <!-- For sandbox----------//5000 //8000 //3000 -------->
    <!-- <a rel="noopener noreferrer"
  href="
https://api.whatsapp.com/send/?phone=447860099299&text=Hi,%20I%20need%20assistance%20in%20booking%20a%20Tata%20vehicle%20online&app_absent=0"
  target="_blank" class="icon"> -->
     <!--For production------- //4000--------->

    <a rel="noopener noreferrer" target="_blank" target="_blank" class="icon">

      <img
        alt="whatsapp" data-toggle="tooltip"
        data-placement="top" title="Fleetverse.ai"
        [src]='environment1 + "assets/images/Chat floating icon.png"'
        width="100%"
        height="100%"
        (click)="loadScript()" id="loadScriptID"
      />
    </a>
  </div>

   <!--  chat floating icon end -->
  <!-- //chatbot start -->
    <div  *ngIf="isShowChatbot"
      [ngClass]="[this.router.url.includes('/product-list') || this.router.url.includes('/product-details') ? 'chat-wrapper1' : 'chat-wrapper']">
      <a href="javascript:void(0);" class="icon chat-icon" (click)="getUrl()">
        <img alt="chat" [src]='environment1 + "assets/images/chat.webp"'  data-toggle="tooltip"
        data-placement="top" title="Other Vehicles"  width="100%" height="100%" />
      </a>
    </div>
  <div class="chat-wrap " *ngIf="isShowChatWin" >
    <a href="javascript:void(0);" class="close-chat" (click)="isShowChatWin = !isShowChatWin">
      <img class="img-fluid" alt="nav-right" [src]='environment1 + "assets/images/nav-right.webp"' loading="lazy"
        width="100%" height="100%" />
    </a>
    <div style="width: inherit">
      <iframe [src]="urlSafe1  | safe: 'resourceUrl'" class="web-Popup">
      </iframe>
    </div>

  </div>
<!-- //chatbot end -->

<!-- new chat widget -->
  <div
  [ngClass]="[this.router.url.includes('/product-list') || this.router.url.includes('/product-details') ? 'chat-widget1' : 'chat-widget']"

  *ngIf="!isShowChatbot" (click)="isShowChatbot = !isShowChatbot">

  <img [src]="environment1 + 'images/new-images/message.svg'" alt="message" loading="lazy">
  </div>
  <div *ngIf="isShowChatbot"
  [ngClass]="[this.router.url.includes('/product-list') || this.router.url.includes('/product-details') ?
   'chat-widget-close1' : 'chat-widget-close']"
  (click)="isShowChatbot ? isShowChatWin ?  isShowChatbot = true && isShowChatWin = false : isShowChatbot =!isShowChatbot : isShowChatbot =!isShowChatbot
   || isShowChatWin ? isShowChatWin = false : isShowChatWin =!isShowChatWin ">
     <img [src]="environment1 + 'images/new-images/close.svg'" alt="close" loading="lazy">
  </div>
<!-- end of new chat widget -->
  <div class="container">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 footer-middle">
        <div class="row">
          <div class="col-12 col-sm-4 col-md-4 col-lg-6 col-xl-6 col-xxl-6 logo-section">
            <a href="https://www.tatamotors.com/" target="_blank" rel="noopener noreferrer" rel="noopener noreferrer"
              class="d-inline-block">
              <img alt="Tata Motors" class="footer-logo" [src]='environment1 + "assets/images/Logo-TM.svg"'>
            </a>
          </div>
          <div class="col-12 col-sm-8 col-md-8 col-lg-6 col-xl-6 col-xxl-6">
            <div class="row">
              <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xxl-3 col-xl-3 footer-link">
                <h3>Trucks</h3>
                <ul *ngFor="let item of footerTruckList?.data">
                  <li>
                    <a (click)="getCall()" [routerLink]="item.link">{{item.display_name}}</a>
                  </li>
                </ul>
              </div>
              <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xxl-3 col-xl-3 footer-link">
                <h3>Buses & Vans</h3>
                <ul *ngFor="let item of footerBusesList?.data">
                  <li>
                    <a (click)="getCall()" [routerLink]="item.link">{{item.display_name}}</a>
                  </li>
                </ul>
              </div>
              <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xxl-3 col-xl-3 footer-link">
                <h3>SCV & Pickups</h3>
                <ul *ngFor="let item of footerSCVList?.data">
                  <li>
                    <a (click)="getCall()" [routerLink]="item.link">{{item.display_name}}</a>
                  </li>
                </ul>
              </div>
              <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xxl-3 col-xl-3 footer-link">
                <h3>Other Links</h3>
                <ul>

                  <li>
                    <a [routerLink]="'/compare'" (click)="SectionClick('Compare')">Compare</a>
                  </li>
                  <li *ngIf="!dealerCode">
                    <a [routerLink]="'/find-dealer'" routerDirection="root"
                      (click)="SectionClick('Find Dealers')">Dealer Outlet Locator</a>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 footer-bottom">
        <div class="row">
          <div class="col-6 col-sm-6 col-md-3 col-lg-4 col-xl-4 col-xxl-4 order-1 order-md-1">
            <ul class="site">
              <li>
                <a routerLink="sitemap" (click)="SectionClick('Sitemap')">Site Map</a>
              </li>
              <li>
                <a routerLink="terms-conditions" (click)="SectionClick('Terms Conditions')">T&C</a>
              </li>
              <li>
                <a [routerLink]="'/privacy-policy'" (click)="SectionClick('Privacy Policy')">Privacy Policy</a>
              </li>
              <li>
                <a [routerLink]="'/about-us'" (click)="SectionClick('About us')" >About us</a>
              </li>
            </ul>
          </div>
          <div
            class="col-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 col-xxl-4 text-left text-md-center copy-right order-3 order-md-2">
            &copy; 2022 Tata Motors. All Rights Reserved.
          </div>
          <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center text-md-end order-2 order-md-3">
            <ul class="social-link">


              <li>
                <a href="https://m.facebook.com/profile.php?id=61563287553151" target="_blank" rel="noopener noreferrer">
                  <img alt="facebook" [src]='environment1 + "assets/images/Facebook_icon_2013 2.svg"' width="100%" height="100%" />

                </a>
              </li>

              <li>
                <a href="https://www.instagram.com/tatamotorsfleetverse/" target="_blank" rel="noopener noreferrer">
                  <img alt="instagram" [src]='environment1 + "assets/images/Instagram_logo_2016 1.svg"' width="100%"
                    height="100%" />

                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/@TataMotorsFleetVerse" target="_blank" rel="noopener noreferrer">
                  <img style="height: 25px;width:25px" alt="youtube" [src]='environment1 + "assets/images/youtube-icon.svg"' width="100%"
                    height="100%" />
                </a>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>
  </div>
</footer>
<div
  [ngClass]="[this.router.url.includes('/product-list') || this.router.url.includes('/product-details')
   ? 'back-to-top1' : 'back-to-top']">
  <a *ngIf="isShow" (click)="gotoTop()">
    <img [src]="environment1 + 'images/new-images/verticalfillarrow.svg'" alt="vertical fillarrow" loading="lazy">

  </a>
</div>
